import { Fragment, useState } from "react";
import {
  Box,
  List,
  IconButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  Tooltip,
  Divider,
  ListItemButton,
  Avatar,
  Collapse,
  Typography,
  Button,
} from "@mui/material";
import {
  ExitToApp,
  ChevronLeft,
  ChevronRight,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import { MenuItems } from "dashboard/configs";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomDrawer, CustomDrawerHeader } from "./custom";
import { Logo } from "asset";
import { signOut } from "firebase/auth";
import { auth } from "configs/firebaseConfigs";

const DrawerLayout = ({ isDrawerOpen, handleDrawerClose }) => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      signOut(auth)
        .then(() => {
          navigate("/", {});
        })
        .catch((error) => {
          // An error happened.
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [selectedSubMenu, setSelectedSubMenu] = useState("");
  return (
    <>
      <CustomDrawer
        variant="permanent"
        open={isDrawerOpen}
        className="drawer-layout"
      >
        <CustomDrawerHeader>
          <Avatar
            src={Logo}
            variant="rounded"
            sx={{ width: "160px", height: "45px", objectFit: "contain" }}
            imgProps={{
              style: {
                objectFit: "contain",
              },
            }}
          />
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? <ChevronRight /> : <ChevronLeft />}
          </IconButton>
        </CustomDrawerHeader>
        <Divider />
        {/* Render Menu Items */}
        <List>
          {MenuItems.map((item) => (
            <Fragment key={item.key}>
              <Tooltip
                title={item.title}
                followCursor
                arrow
                placement="top-end"
              >
                <ListItemButton
                  className="drawer-menu"
                  onClick={() =>
                    item?.submenus
                      ? setSelectedSubMenu((prev) =>
                          prev === item.key ? "" : item.key
                        )
                      : navigate(item.route, {})
                  }
                  selected={
                    item?.submenus
                      ? selectedSubMenu === item?.key
                      : location.pathname === item.route
                  }
                >
                  <ListItemIcon className="drawer-menu-icon">
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.title}
                    sx={{
                      textTransform: "Capitalize",
                    }}
                  />
                  {item?.submenus &&
                    (selectedSubMenu === item?.key ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    ))}
                </ListItemButton>
              </Tooltip>
              {item?.submenus && (
                <Collapse
                  in={selectedSubMenu === item?.key}
                  timeout="auto"
                  unmountOnExit
                >
                  <List
                    component="div"
                    disablePadding
                    sx={{
                      backgroundColor: "#cdcdcd54",
                    }}
                  >
                    {item?.submenus.map((submenu) => (
                      <ListItemButton
                        onClick={() => navigate(submenu.route, {})}
                        sx={{ pl: 4, paddingY: 1.2 }}
                        selected={location.pathname === submenu.route}
                        key={submenu?.key}
                      >
                        <ListItemIcon>{submenu?.icon}</ListItemIcon>

                        <ListItemText
                          primary={submenu?.title}
                          sx={{ whiteSpace: "break-spaces" }}
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              )}
            </Fragment>
          ))}

          {/* <Box hidden={isDrawerOpen}>
            <Tooltip
              title={"Click Here To Logout"}
              followCursor
              arrow
              placement="top-end"
            >
              <ListItemButton onClick={handleLogout}>
                <ListItemIcon>
                  <ExitToApp />
                </ListItemIcon>
                <ListItemText primary={"Logout"} />
              </ListItemButton>
            </Tooltip>
          </Box> */}
        </List>
        <Box
          hidden={!isDrawerOpen}
          sx={{
            textAlign: "center",
            paddingY: "1rem",
          }}
        >
          <Typography> Hi' Admin,</Typography>
          <Typography variant="caption">
            Click here to logout from panel
          </Typography>
          <div className="drawer-layout-logout">
            <Button
              variant="contained"
              onClick={handleLogout}
              startIcon={<ExitToApp />}
            >
              Logout
            </Button>
          </div>
        </Box>
      </CustomDrawer>
    </>
  );
};

export default DrawerLayout;
